import React, { useState } from 'react'
import { css } from '@emotion/react'
import { string, bool, element, object } from 'prop-types'
import { connect } from 'react-redux'
import { Button } from '@livechat/design-system-react-components'

import { useOnboarding } from '@/context/OnboardingContext'
import { handleDirectInstallationUrlFlow } from '@/utils/products'
import {
  getPublishedApp,
  hasAppAuthorization,
  getAppPayment,
  hasExternalLink,
  hasDirectInstallUrlInNewTab,
  canInstallApplications,
} from '@/store/selectors'

const btnCss = ({ colors }) => css`
  background-color: ${colors.orange500};
  border: 1px solid ${colors.orange500};

  :hover {
    background-color: ${colors.orange600};
    border: 1px solid ${colors.orange600};
  }

  &:focus {
    box-shadow: 0 0 1px 2px ${colors.orange500};
  }
`

const OnboardingButton = ({
  canInstallApplication,
  icon,
  size,
  disabled,
  className,
  fullWidth,
  name,
  externalLink,
  hasAuth,
  openDirectInstallUrlInNewTab,
}) => {
  const { checkOnboarding, isConfigured } = useOnboarding()
  const [isLoading, setIsLoading] = useState(false)

  const displayPopup = () => {
    if (canInstallApplication) {
      handleDirectInstallationUrlFlow({
        name,
        directInstallUrl: externalLink,
        clientId: hasAuth?.clientId,
        onClose: checkOnboarding,
        openInNewTab: openDirectInstallUrlInNewTab,
      })
    }

    setIsLoading(false)
  }

  const handleClick = (e) => {
    e.preventDefault()

    setIsLoading(true)
    displayPopup()
  }

  const copy = !isConfigured ? 'Connect app' : 'Accept'

  return (
    <Button
      css={btnCss}
      data-test="install-btn"
      icon={icon || ''}
      size={size}
      disabled={isLoading || disabled || !canInstallApplication}
      onClick={handleClick}
      className={className}
      kind="primary"
      fullWidth={fullWidth}
    >
      {copy}
    </Button>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const { name } = getPublishedApp(state, id)

  return {
    name,
    hasAuth: hasAppAuthorization(state, id),
    payment: getAppPayment(state, id),
    canInstallApplication: canInstallApplications(state),
    externalLink: hasExternalLink(state, id),
    openDirectInstallUrlInNewTab: hasDirectInstallUrlInNewTab(state, id),
  }
}

OnboardingButton.propTypes = {
  className: string,
  icon: element,
  size: string,
  disabled: bool,
  fullWidth: bool,
  id: string,
  name: string,
  hasAuth: object,
  canInstallApplication: bool,
  openDirectInstallUrlInNewTab: bool,
  externalLink: string,
}

export default connect(mapStateToProps, null)(OnboardingButton)
